import { storage } from './storage';

// Centralized test mode detection utility
export const isTestMode = (): boolean => {
  // Check multiple sources for test mode
  const urlParams = new URLSearchParams(window.location.search);
  const urlTestMode = urlParams.get('test') === 'true';
  const envTestMode = process.env.REACT_APP_TEST_MODE === 'true';
  const nodeEnvTest = process.env.NODE_ENV === 'test';
  const localStorageTestMode = storage.getItem('test-mode') === 'true';
  
  const testModeActive = urlTestMode || envTestMode || nodeEnvTest || localStorageTestMode;
  
  if (testModeActive) {
    console.log('🧪 Test mode detected:', {
      urlTestMode,
      envTestMode,
      nodeEnvTest,
      localStorageTestMode
    });
  }
  
  return testModeActive;
};

// Enable test mode programmatically
export const enableTestMode = (): void => {
  storage.setItem('test-mode', 'true');
  console.log('🧪 Test mode enabled programmatically');
}; 